import { render, staticRenderFns } from "./VehicleUsages.vue?vue&type=template&id=59059878&scoped=true"
import script from "./VehicleUsages.vue?vue&type=script&lang=ts"
export * from "./VehicleUsages.vue?vue&type=script&lang=ts"
import style0 from "./VehicleUsages.vue?vue&type=style&index=0&id=59059878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59059878",
  null
  
)

export default component.exports